import { render, staticRenderFns } from "./ConfirmBox.vue?vue&type=template&id=41b4ec37"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBox.vue?vue&type=style&index=0&id=41b4ec37&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports